// extracted by mini-css-extract-plugin
export var base = "_2r-0";
export var updateBanner = "_2r-1";